import { Component } from '@angular/core';
import { PropertyService } from '../shared/property.service';

@Component({
  selector: 'sold-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.scss']
})
export class FeaturesComponent {

  constructor(public _propertyService: PropertyService) { }

}



// WEBPACK FOOTER //
// D:/FLINK/FlinkViewingPageDec2020/NewLandingPage/src/app/features/features.component.ts